import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'
import axios from 'axios'
import { generateRandomString } from './common';

export const GetDeviceFeatureSerials = async () => {
    return apiGet({ endpoint: `${process.env.REACT_APP_FEATURES_API_URL}/get_device_features_serials`, error_message: "Failed to fetch." });
};

export const CreateDeviceFeatureSerials = async (data) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_FEATURES_API_URL}/create_device_features_serials`, body: data, error_message: "Failed to create." });
};

export const GetFeaturesByOrg = async (org_id) => {
    return axios.get(`${process.env.REACT_APP_FEATURES_API_URL}/get_features_by_org/${org_id}`)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
}

export const CreatePaymentSession = async (data) => {
    return axios.post(`${process.env.REACT_APP_FEATURES_API_URL}/create_payment_session`, data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const CheckPaymentStatus = async (data) => {
    return axios.post(`${process.env.REACT_APP_FEATURES_API_URL}/check_payment_status`, data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const GetFeaturesByDevice = async (device_id) => {
    return axios.get(`${process.env.REACT_APP_FEATURES_API_URL}/get_features/${device_id}`)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
}


export const CreateFeatureTrial = async (data) => {
    return axios.post(`${process.env.REACT_APP_FEATURES_API_URL}/create_feature_trial`, data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
}

export const UpdateFeatureTrial = async (data) => {
  return axios
    .post(`${process.env.REACT_APP_FEATURES_API_URL}/update_feature_trial`, data)
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
};

export const GetImageCatogory = async () => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_ORIGIN}/portalimage/get_image_category`, error_message: "Failed to get categories." });
};

export const GetCatogoryImage = async (cateogry_id) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_ORIGIN}/portalimage/get_category_imaages/${cateogry_id}`, error_message: "Failed to get category images." });
};

export const CreateImageCatogory = async (categoryName) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_API_ORIGIN}/portalimage/create_image_category`, body: categoryName, error_message: "Failed to create category." });
};

export const UpdateImageCatogory = async (categoryName) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_API_ORIGIN}/portalimage/rename_image_category`, body: categoryName, error_message: "Failed to update category." });
};

export const DeleteCatogoryImage = async (image_id) => {
    return apiDelete({ endpoint: `${process.env.REACT_APP_API_ORIGIN}/portalimage/delete_category_imaages/${image_id}`, error_message: "Failed to delete category images." });
};

export const UploadImageDetails = async (categoryId, file) => {
    try {
        if (!categoryId || !file) {
            return { success: false, error: "Missing required parameters for image upload" };
        }

        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(
            `${process.env.REACT_APP_API_ORIGIN}/portalimage/upload_cateogry_image?categoryId=${categoryId}`,
            {
                method: 'POST',
                headers: {
                    'portalscope': 'b3NMWOVzfdRUjrW',
                    'validatereq': generateRandomString(30)
                },
                body: formData,
                credentials: 'include',
            }
        );

        if (response.ok) {
            return { success: true, message: "Image uploaded successfully" };
        } else {
            console.error(`Failed to upload image: ${response.status}`);
            return { success: false, error: "Failed to upload image" };
        }
    } catch (error) {
        console.error("Error uploading image:", error);
        return { success: false, error: error.message };
    }
};